// Transfers/utils/time.js

// Pull "HH:mm:ss" out of an ISO-ish datetime string (or return "")
export function hhmmss(dtVal) {
  if (!dtVal) return "";
  const s = String(dtVal);
  // Handles "2026-01-27T08:00:00Z", "2026-01-27 08:00:00", etc.
  const m = s.match(/(\d{2}:\d{2}:\d{2})/);
  return m ? m[1] : "";
}
